import React from 'react';
import './Home.css';

function Home({ onNavigate }) {
  return (
    <div className="home-container">
      <div className="music-background">
        {/* 音符装饰 */}
        <div className="floating-notes">
          <span className="note note-1">♪</span>
          <span className="note note-2">♫</span>
          <span className="note note-3">♪</span>
          <span className="note note-4">♬</span>
          <span className="note note-5">♫</span>
          <span className="note note-6">♪</span>
        </div>

        {/* 主要内容 */}
        <div className="home-content">
          <div className="logo-section">
            <div className="logo-circle">
              <span className="logo-icon">🐱</span>
            </div>
            <h1 className="app-title">
              <span className="title-part">喵喵</span>
              <span className="title-part highlight">合唱团</span>
            </h1>
            <p className="app-subtitle">Meow Meow Choir</p>
            <p className="app-description">让每只小猫都能唱出美妙的旋律 🎵</p>
          </div>

          <div className="action-buttons">
            <button 
              className="action-btn primary"
              onClick={() => onNavigate('editor')}
            >
              <span className="btn-icon">🎹</span>
              <span className="btn-text">开始创作</span>
            </button>
            
            <div className="secondary-buttons">
              <button 
                className="action-btn secondary"
                onClick={() => onNavigate('docs-zh')}
              >
                <span className="btn-icon">📖</span>
                <span className="btn-text">中文文档</span>
              </button>
              
              <button 
                className="action-btn secondary"
                onClick={() => onNavigate('docs-en')}
              >
                <span className="btn-icon">📘</span>
                <span className="btn-text">English Docs</span>
              </button>
            </div>
          </div>

          <div className="features">
            <div className="feature-card">
              <span className="feature-icon">🐱</span>
              <h3>喵喵琴</h3>
              <p>24音符，完整半音阶</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🎹</span>
              <h3>钢琴</h3>
              <p>36音符，3个八度</p>
            </div>
            <div className="feature-card">
              <span className="feature-icon">🥁</span>
              <h3>架子鼓</h3>
              <p>10个专业鼓垫</p>
            </div>
          </div>

          <footer className="home-footer">
            <p>🎼 支持简谱编辑 | 🎵 实时预览 | 💾 导入导出</p>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default Home;

